'use strict'

cpntMap.set('awe-warning', {
  props: {
    test: { type: Boolean, default: false },
    noCache: { type: Boolean, default: false }
  },
  data: function() {
    return {
      i18n: this.$root.i18n
    }
  },
  methods: {
    close: function(e) {
      this.$root.showWarning = false
      e.stopPropagation()
    }
  },
  template: `
    <div id="awe-warning" role="note">
      <div class="texts" role="presentation">
        <span v-if="test">This widget uses a test configuration!</span>
        <span v-if="noCache">Caching is disabled!</span>
      </div>
      <span id="wrn-close" v-on:click="close" v-on:keypress.enter="close" role="button" :aria-label="i18n.getString('CLOSE_WARNING')">x</span>
    </div>
  `
})
